export default __webpack_public_path__ + "static/media/bg_mobile.a7b9821f.png";